<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M8.5 1C12.0899 1 15 3.68629 15 7C15 10.3137 12.0899 13 8.5 13C7.44178 13 6.44351 12.7647 5.56055 12.3506L5.45215 12.4385C4.18847 13.4494 2.61828 14 1 14C2.21759 13.0868 2.78813 11.5453 2.45801 10.0596L2.2168 8.97656C2.07261 8.32772 2 7.66467 2 7C2 3.68629 4.91015 1 8.5 1ZM7.76953 4.92383C6.8926 5.65466 6.28757 6.50952 5.88867 7.21777C5.81709 7.34487 5.75719 7.44912 5.70703 7.53613C5.658 7.47572 5.60106 7.40489 5.53418 7.32129L5.33594 7.07324L4.86719 6.4873L3.69629 7.4248L4.16406 8.00977L4.36328 8.25879C4.52222 8.45747 4.66587 8.6388 4.78906 8.77246C4.89327 8.88552 5.08715 9.0854 5.36328 9.17383C5.5007 9.21779 5.66309 9.24918 5.8457 9.23438C6.02832 9.21952 6.18398 9.16321 6.3125 9.09766C6.57891 8.96165 6.74358 8.71252 6.82715 8.58398C6.93277 8.42148 7.05534 8.20262 7.19531 7.9541C7.5327 7.35506 8.03106 6.65901 8.73047 6.07617L9.30664 5.5957L8.3457 4.44336L7.76953 4.92383ZM9.5 6.5V8H13V6.5H9.5Z"
    fill="currentColor"
  />
</svg>
